import { Flex } from 'antd';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const CleaningAreaRow = styled(Flex)<{ $isOverlay?: boolean }>`
  ${({ theme: { kcc }, $isOverlay }): FlattenSimpleInterpolation => css`
    position: relative;
    flex-shrink: 0;
    height: 50px;
    padding-inline-end: ${kcc.spacing.BASE};
    border: ${$isOverlay ? 'none' : `2px solid ${kcc.colors.BORDER}`};
    border-radius: ${$isOverlay ? '24px' : 0};
    box-shadow: ${$isOverlay ? '0px 0px 30px 0px #0000001A' : 'none'};
    background-color: ${kcc.colors.BG_CONTAINER};
    overflow: ${$isOverlay ? 'hidden' : 'visible'};
  `}
`;
